module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "pt-sans",
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "ma-0": "",
      "pa-0": "",
      "fluid": ""
    }
  }, [_c('v-layout', {
    staticClass: "sub-tab-color mb-3",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "offset-md1": "",
      "md10": ""
    }
  }, [_c('v-tabs', {
    staticClass: "sub-tab",
    attrs: {
      "value": _vm.caminho,
      "slider-color": "blue"
    }
  }, _vm._l(((_vm.tabs !== null ? _vm.tabs : [])), function(tab) {
    return _c('v-tab', {
      key: _vm.rota + tab.url,
      attrs: {
        "ripple": false,
        "to": _vm.rota + tab.url
      }
    }, [_vm._v("\n          " + _vm._s(tab.nome) + "\n        ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('v-slide-x-transition', {
    attrs: {
      "mode": "out-in"
    }
  }, [_c('div', {}, [_vm._t("default"), _vm._v(" "), _c('router-view', {
    class: _vm.loading ? 'blur' : 'blur confirmado'
  })], 2)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-72d2f250","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/painel/SubTabs.vue
// module id = 409
// module chunks = 0 1 24 25 26 27 28